import { portRateConstants } from '../../_constants';

export function portRates(state = {}, action) {
    switch (action.type) {
        case portRateConstants.PORT_RATE_FETCHING:
            return {
                ...state,
                portRateFetching: true
            };
        case portRateConstants.PORT_RATE_FETCHED:
            return {
                ...state,
                portRateFetching: false
            };
        case portRateConstants.GET_ALL_PORT_RATES:
            return {
                ...state,
                portRates: action.portRates
            };
        case portRateConstants.GET_PORT_RATES:
            return {
                ...state,
                portRates: action.portRates
            };
        case portRateConstants.GET_PORT_RATE_BY_ID:
            return {
                ...state,
                portRate: action.portRate
            };
        case portRateConstants.UPDATE_PORT_RATE:
            return {
                ...state,
                updating: true
            };
        case portRateConstants.SEARCH_PORT_RATES:
            return {
                ...state,
                portRates: action.portRates
            };
        case portRateConstants.PORTRATE_GROUP_BY_CHARGE:
            return {
                ...state,
                portRatesCharge: action.portRatesCharge
            };
        case portRateConstants.PORTRATE_BY_CHARGE:
            return {
                ...state,
                portRates: action.portRates
            };
        default:
            return state;
    }
}